import { useCallback } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";

import useModulesAnalytics from "../../useModulesAnalytics";

const ModulesTableDescriptionCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();

  const handleShowFullDescription = useCallback(() => {
    trackAnalytics("Show full description clicked");
  }, [trackAnalytics]);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription
        description={module.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </TableSimpleCell>
  );
};

export default ModulesTableDescriptionCell;
